import { isDev } from "config/env";

export const scrollToTop = () => {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
};

export const planIdProperty = isDev ? "prodId" : "prodId";
